import React, { useState } from "react";

const C = {
  bg:     "#C4622D",
  forest: "#2D5A3D",
  dark:   "#1C3A28",
  text:   "#1C1C1E",
  muted:  "#8A8A8E",
  ok:     "#2D9E4A",
  warn:   "#D97706",
  nok:    "#C4622D",
};


function StateBtn({ active, activeColor, activeTextColor = "white", label, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        flex: 1, padding: "7px 2px",
        borderRadius: 8, border: "none",
        background: active ? activeColor : "#F0F0EC",
        color: active ? activeTextColor : C.muted,
        fontSize: 11, fontWeight: 800,
        cursor: "pointer", fontFamily: "inherit",
        transition: "background 0.15s, color 0.15s",
        letterSpacing: 0.2,
        boxShadow: active ? `0 2px 8px ${activeColor}55` : "none",
      }}
    >
      {label}
    </button>
  );
}

function CategoryGroup({ cat, catIds, checks, onCheck, open, onToggle, t = {}, items = {} }) {
  const nOk   = catIds.filter(id => checks[id] === "ok").length;
  const nWarn = catIds.filter(id => checks[id] === "warn").length;
  const nNok  = catIds.filter(id => checks[id] === "nok").length;
  const total = catIds.length;
  const allOk = nOk === total;

  return (
    <div style={{ marginBottom: 6, borderRadius: 12, overflow: "hidden" }}>

      <button
        onClick={onToggle}
        style={{
          width: "100%", display: "flex", alignItems: "center",
          justifyContent: "space-between", padding: "12px 16px",
          background: C.dark, border: "none", cursor: "pointer", fontFamily: "inherit",
        }}
      >
        <span style={{ fontSize: 12, fontWeight: 800, color: "#F8F6F1", letterSpacing: 1 }}>
          {cat.toUpperCase()}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {nOk   > 0 && (
            <span style={{ fontSize: 10, fontWeight: 800, color: C.ok, background: "rgba(45,158,74,0.18)", borderRadius: 6, padding: "2px 6px" }}>
              ✅ {nOk}
            </span>
          )}
          {nWarn > 0 && (
            <span style={{ fontSize: 10, fontWeight: 800, color: "#A85E00", background: "#F5D78E", borderRadius: 6, padding: "2px 6px" }}>
              ! {nWarn}
            </span>
          )}
          {nNok  > 0 && (
            <span style={{ fontSize: 10, fontWeight: 800, color: C.nok, background: "rgba(196,98,45,0.18)", borderRadius: 6, padding: "2px 6px" }}>
              ❌ {nNok}
            </span>
          )}
          <span style={{ fontSize: 11, fontWeight: 700, color: allOk ? "#9FE1CB" : "rgba(248,246,241,0.45)" }}>
            {nOk}/{total}
          </span>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
            style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}
          >
            <path d="M2 4L6 8L10 4" stroke="rgba(248,246,241,0.55)"
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </button>

      {open && (
        <div style={{
          background: "white",
          borderLeft:   `2px solid ${C.dark}`,
          borderRight:  `2px solid ${C.dark}`,
          borderBottom: `2px solid ${C.dark}`,
          borderRadius: "0 0 12px 12px",
        }}>
          {catIds.map((id, idx) => {
            const item = items[id];
            const val  = checks[id];
            return (
              <div
                key={id}
                style={{
                  padding: "11px 14px",
                  borderBottom: idx < catIds.length - 1 ? "1px solid #EDEDEA" : "none",
                  background: val === "nok" ? "#FFF8F7"
                            : val === "warn" ? "#FFFBF0"
                            : val === "ok"   ? "#F5FBF6"
                            : "white",
                  transition: "background 0.15s",
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{item.label}</span>
                  <span style={{ fontSize: 11, color: C.muted, marginLeft: 6 }}>{item.desc}</span>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <StateBtn
                    active={val === "ok"} activeColor={C.ok} label="✅ OK"
                    onClick={() => onCheck(id, val === "ok" ? null : "ok")}
                  />
                  <StateBtn
                    active={val === "warn"} activeColor="#F5D78E" activeTextColor="#A85E00" label={t.attentionBtn || "Attention !"}
                    onClick={() => onCheck(id, val === "warn" ? null : "warn")}
                  />
                  <StateBtn
                    active={val === "nok"} activeColor={C.nok} label={t.problemeBtn || "❌ Problème"}
                    onClick={() => onCheck(id, val === "nok" ? null : "nok")}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function ChecklistScreen({ checks, onCheck, subTabBar, t = {} }) {
  const [openCat, setOpenCat] = useState(null);

  const ITEMS = {
    ent_huile:      { label: t.ent_huile      || "Niveau d'huile moteur",        desc: t.ent_huile_desc      || "Jauge entre min et max",        cat: t.catMoteur    || "Moteur & Fluides" },
    ent_refroid:    { label: t.ent_refroid    || "Liquide de refroidissement",   desc: t.ent_refroid_desc    || "Niveau au repère froid",         cat: t.catMoteur    || "Moteur & Fluides" },
    ent_frein:      { label: t.ent_frein      || "Liquide de frein",             desc: t.ent_frein_desc      || "Au-dessus du minimum",           cat: t.catMoteur    || "Moteur & Fluides" },
    ent_laveglace:  { label: t.ent_laveglace  || "Lave-glace",                   desc: t.ent_laveglace_desc  || "Réservoir plein",                cat: t.catMoteur    || "Moteur & Fluides" },
    ent_filtre_air: { label: t.ent_filtre_air || "Filtre à air",                 desc: t.ent_filtre_air_desc || "État et propreté",               cat: t.catMoteur    || "Moteur & Fluides" },
    ent_pression:   { label: t.ent_pression   || "Pression des pneus",           desc: t.ent_pression_desc   || "Conforme constructeur",          cat: t.catPneus     || "Pneumatiques" },
    ent_usure_av:   { label: t.ent_usure_av   || "Usure pneus avant",            desc: t.ent_usure_av_desc   || "Sculptures > 1,6 mm",            cat: t.catPneus     || "Pneumatiques" },
    ent_usure_ar:   { label: t.ent_usure_ar   || "Usure pneus arrière",          desc: t.ent_usure_ar_desc   || "Sculptures > 1,6 mm",            cat: t.catPneus     || "Pneumatiques" },
    ent_secours:    { label: t.ent_secours    || "Roue de secours",              desc: t.ent_secours_desc    || "Gonflée et accessible",          cat: t.catPneus     || "Pneumatiques" },
    ent_phares:     { label: t.ent_phares     || "Phares et feux avant",         desc: t.ent_phares_desc     || "Fonctionnels",                   cat: t.catEclairage || "Éclairage" },
    ent_stop:       { label: t.ent_stop       || "Feux stop",                    desc: t.ent_stop_desc       || "Fonctionnels",                   cat: t.catEclairage || "Éclairage" },
    ent_cligno:     { label: t.ent_cligno     || "Clignotants",                  desc: t.ent_cligno_desc     || "Avant et arrière",               cat: t.catEclairage || "Éclairage" },
    ent_recul:      { label: t.ent_recul      || "Feux de recul + plaque",       desc: t.ent_recul_desc      || "Fonctionnels",                   cat: t.catEclairage || "Éclairage" },
    ent_ce_freins:  { label: t.ent_ce_freins  || "Freins",                       desc: t.ent_ce_freins_desc  || "Usure et efficacité",            cat: t.catCellule   || "Cellule équipements" },
    ent_ce_batt:    { label: t.ent_ce_batt    || "Batterie",                     desc: t.ent_ce_batt_desc    || "Charge et état général",         cat: t.catCellule   || "Cellule équipements" },
    ent_ce_essuie:  { label: t.ent_ce_essuie  || "Essuie-glaces",                desc: t.ent_ce_essuie_desc  || "État des balais",                cat: t.catCellule   || "Cellule équipements" },
    ent_ce_clim:    { label: t.ent_ce_clim    || "Climatisation",                desc: t.ent_ce_clim_desc    || "Fonctionnelle et filtre propre", cat: t.catCellule   || "Cellule équipements" },
  };

  const CAT_ORDER = [
    t.catMoteur    || "Moteur & Fluides",
    t.catPneus     || "Pneumatiques",
    t.catEclairage || "Éclairage",
    t.catCellule   || "Cellule équipements",
  ];

  const ALL_IDS = Object.keys(ITEMS);

  const nOk   = ALL_IDS.filter(id => checks[id] === "ok").length;
  const nWarn = ALL_IDS.filter(id => checks[id] === "warn").length;
  const nNok  = ALL_IDS.filter(id => checks[id] === "nok").length;
  const total = ALL_IDS.length;
  const pct   = total ? Math.round((nOk / total) * 100) : 0;
  const allOk  = nOk === total;
  const hasNok = nNok > 0;

  return (
    <div style={{ background: C.bg, minHeight: "calc(100vh - 168px)", paddingBottom: 24 }}>

      <div style={{ background: C.forest, padding: "20px 20px 0" }}>
        <div style={{ fontSize: 22, fontWeight: 900, color: "#F8F6F1", textAlign: "center" }}>{t.checklist || "Checklist"}</div>
        <div style={{ fontSize: 12, color: "rgba(248,246,241,0.65)", marginTop: 3, marginBottom: 14, textAlign: "center" }}>
          {t.entretienVehicule || "Entretien du véhicule"}
        </div>
      </div>
      {subTabBar && subTabBar}

      <div style={{ padding: "14px 14px 0" }}>

        <div style={{ background: C.dark, borderRadius: 12, padding: "12px 16px", marginBottom: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: "rgba(248,246,241,0.7)" }}>{t.progression || "Progression"}</span>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {nWarn > 0 && (
                <span style={{ fontSize: 11, fontWeight: 800, color: "#A85E00", background: "#F5D78E", borderRadius: 5, padding: "1px 6px" }}>{nWarn} {t.attention || "attention"}</span>
              )}
              {nNok > 0 && (
                <span style={{ fontSize: 11, fontWeight: 800, color: C.nok }}>{nNok} {t.probleme || "problème"}{nNok > 1 ? "s" : ""}</span>
              )}
              <span style={{ fontSize: 12, fontWeight: 800, color: "#9FE1CB" }}>{nOk}/{total}</span>
            </div>
          </div>
          <div style={{ height: 6, background: "rgba(255,255,255,0.12)", borderRadius: 99, overflow: "hidden" }}>
            <div style={{
              height: "100%", width: `${pct}%`,
              background: allOk ? C.ok : "#9FE1CB",
              borderRadius: 99, transition: "width 0.4s ease",
            }} />
          </div>
        </div>

        {allOk && (
          <div style={{
            background: "#EAF3DE", borderRadius: 10,
            padding: "11px 16px", marginBottom: 10,
            display: "flex", alignItems: "center", gap: 10,
          }}>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path d="M1 6L5.5 11L15 1" stroke="#085041" strokeWidth="2.2"
                strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontSize: 13, fontWeight: 800, color: "#085041" }}>
              {t.entretienComplet || "Entretien complet — tout est OK !"}
            </span>
          </div>
        )}
        {hasNok && (
          <div style={{
            background: "#FEF2F2", borderRadius: 10,
            padding: "11px 16px", marginBottom: 10,
            display: "flex", alignItems: "center", gap: 8,
          }}>
            <span style={{ fontSize: 14 }}>⚠️</span>
            <span style={{ fontSize: 13, fontWeight: 800, color: C.nok }}>
              {nNok} {t.pointsARegler || "point(s) à régler"}
            </span>
          </div>
        )}

        {CAT_ORDER.map((cat) => {
          const catIds = ALL_IDS.filter(id => ITEMS[id].cat === cat);
          return (
            <CategoryGroup
              key={cat}
              cat={cat}
              catIds={catIds}
              checks={checks}
              onCheck={onCheck}
              open={openCat === cat}
              onToggle={() => setOpenCat(c => c === cat ? null : cat)}
              t={t}
              items={ITEMS}
            />
          );
        })}


      </div>
    </div>
  );
}
